export const COLLECTION_ROOT_ICON_SHAPE = '#collection_root'
export const COLLECTION_TABLE_ICON_SHAPE = '#collection_table'
export const COLLECTION_BOARD_ICON_SHAPE = '#collection_board'
export const CHANNEL_ICON_SHAPE = '#channel'
export const SUPER_ASSISTANT_ICON_SHAPE = '#ask_space'
export const SUPER_DIGEST_ICON_SHAPE = '#super_digest'
